import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Error, TableGroup, Width } from '@figure/frontlib-gui';
import { reduxPropTypes } from '@figure/frontlib-onboarding-redux';
import * as Types from 'shared/constants/ach-pay';
import AccountError from './AccountError';

const TableWrapper = styled.div`
  @media print, screen and (max-width: ${Width.SM - 1}px) {
    width: 100%;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }

  h3 {
    margin-bottom: 15px;
  }
`;

// dumb overrides for table group
const TableContainer = styled.div`
  table {
    white-space: nowrap;
    margin-bottom: 25px;

    thead tr th:nth-of-type(2) {
      padding-left: 15px;

      @media print, screen and (max-width: ${Width.SM - 1}px) {
        display: none;
      }
    }

    tbody td {
      font-weight: 600;
      text-align: right;

      &:nth-of-type(2) {
        white-space: normal;
        text-align: left;
        @media print, screen and (max-width: ${Width.SM - 1}px) {
          display: none;
        }
      }

      @media print, screen and (max-width: ${Width.SM - 1}px) {
        max-width: 100px;
      }

      @media print, screen and (max-width: ${Width.MD - 1}px) {
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: right;
      }
    }
  }
`;

const AccountList = ({ items, renderHeader, renderRow, handleRetry, errorText }) => {
  const renderTableGroup = (item) => {
    let content = null;
    if (item.assetsFailed) {
      content = (
        <AccountError
          text="We had trouble connecting to the account."
          handleRetry={item.retryable || item.loginRequired ? () => handleRetry(item) : null}
        />
      );
    } else if (
      !item.login?.accounts?.some(
        (account) => account.accountType?.toUpperCase() === Types.CHECKING
      )
    ) {
      content = (
        <AccountError text={item.inProgress || !item.login ? '' : 'No checking accounts found.'} />
      );
    } else {
      content = item.login.accounts
        .sort((a1, a2) => {
          if (a1.name < a2.name) return -1;
          if (a1.name > a2.name) return 1;
          return a1.plaidAccountId < a2.plaidAccountId ? -1 : 1;
        })
        .map((a) => renderRow({ ...a, institution: item.institution }));
    }

    return (
      <TableContainer>
        <TableGroup>{content}</TableGroup>
      </TableContainer>
    );
  };

  return (
    <>
      {items.map((item) => (
        <TableWrapper key={item.uuid}>
          {renderHeader(item)}
          {renderTableGroup(item)}
        </TableWrapper>
      ))}

      <Error display="block">{errorText}</Error>
    </>
  );
};

AccountList.propTypes = {
  items: PropTypes.arrayOf(reduxPropTypes.plaidItem).isRequired,
  renderHeader: PropTypes.func.isRequired,
  renderRow: PropTypes.func.isRequired,
  handleRetry: PropTypes.func.isRequired,
  errorText: PropTypes.string,
};

AccountList.defaultProps = {
  errorText: '',
};

export default AccountList;
